
import { useEffect, useState } from "react";
import GET_POOLS from "../../utils/queries/pool/getPoolsQueryNew";
import graphQLClient from "../../utils/authHeader";

const usePoolsWithStatus = (status: string[], limit = 10, listType = 'all') => {
    const [pools, setPools] = useState<any[]>([]);
    const [error, setError] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [page, setPoolspage] = useState(1);
    const [count, setCount] = useState(0);
    const [paginatedResult, setPaginatedResult] = useState<any[]>([]);

    useEffect(() => {
        fetchPools(page, limit);
    }, [limit, page])

    const fetchPools = (page: number, limit: number, isPaginated = false) => {
        setLoading(true);
        const variables = {
            type: status.join(','),
            rows: limit,
            page: page,
            listType: listType,
        }
        graphQLClient
        .request(GET_POOLS, variables)
        .then((response: any) => {
            setPaginatedResult([...response.pools.rows]);
            if (!isPaginated)  setPools((prev) => [...prev, ...response.pools.rows]);
            if (count !== response.pools.count) {
                setCount(Number(response.pools.count));
            }
        })
        .catch((error: any) => {
            setError(error);
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const fetchNext = () => {
        setPoolspage((prev) => prev + 1);
    }

    const fetchPage = (page: number) => {
        fetchPools(page, limit, true);
    }

    return {
        pools,
        paginatedResult,
        error,
        isLoading,
        count,
        setPoolspage,
        fetchNext,
        page,
        fetchPage,
    }
}

export default usePoolsWithStatus;